import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth.js';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/ProjectList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/projects/:id',
    name: 'project-editor',
    component: () => import('../views/ProjectEditor.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:id/simulate',
    name: 'simulator',
    component: () => import('../views/Simulator.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('../views/AdminUsers.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/activity',
    name: 'admin-activity',
    component: () => import('../views/AdminActivity.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/simulator',
    name: 'admin-simulator',
    component: () => import('../views/StandaloneSimulator.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/feature-flags',
    name: 'admin-feature-flags',
    component: () => import('../views/AdminFeatureFlags.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/kernel-versions',
    name: 'admin-kernel-versions',
    component: () => import('../views/AdminKernelVersions.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();

  // On first navigation, fetch user session
  if (auth.loading && !auth.user) {
    await auth.fetchUser();
  }

  // Redirect unauthenticated users to login
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }

  // Redirect non-admins away from admin routes
  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return { name: 'home' };
  }
});
